import React from 'react'
import { Navigate } from 'react-router-dom'
import { useParamountAuth } from 'context/ParamountAuthContext'
import ClientAdd from 'pages/clients/Add/Add'
import '../../App.scss'
import './SelfRegisterCompany.scss'

export default function SelfRegisterCompany() {

  const { userRoles } = useParamountAuth()
  // Only show to unregistered users
  if (!userRoles.includes('Unregistered')) {
    return <Navigate to="/unauthorised" replace />
  }

  return (
    <>
    <div className="registration-container">
      <div className="registration-header-text">Finish your registration to get started, and we’ll review your application within 1–2 business days</div>
      <ClientAdd 
        isSelfRegistration={true}
        onSuccessUrl='/company/under_review'
      />
    </div>
    </>
  )
}